module.exports = __webpack_public_path__ + "img/icon-statistics-active.7a4cb3d6.svg";